import React from "react";
import * as Sentry from "@sentry/react";
import { SENTRY_ENVIRONMENT, SENTRY_DSN } from "../configs/sentryConfig";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

Sentry.init({
  dsn: SENTRY_DSN,
  environment: SENTRY_ENVIRONMENT,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Non-Error rejections/captures carry no stack and are not actionable.
  // Sentry v8 renames these vs v7, so match both wordings:
  //   v7: "Non-Error promise rejection captured with ..."
  //   v8: "Object captured as exception with keys: ..." / "Non-Error exception captured ..."
  ignoreErrors: [
    "Non-Error promise rejection captured",
    "Non-Error exception captured",
    /Object captured as exception with keys/,
  ],
  // Performance Monitoring
  tracesSampleRate: 0.5, //  Capture 50% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    "localhost",
    /^https+:\/\/\[\w-]+\.*chat\.988lifeline\.org\//,
    /^https:\/\/chat\.988lifeline\.org\//,
  ],
  // Set profilesSampleRate to 1.0 to profile every transaction.
  // Since profilesSampleRate is relative to tracesSampleRate,
  // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
  // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
  // results in 25% of transactions being profiled (0.5*0.5=0.25)
  profilesSampleRate: 0.5,
  // Session Replay
  replaysSessionSampleRate: 0.0, // This sets the sample rate at 0%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
